<!-- Merchant Portal Theming -->
<div class="theme-header sticky-header">
  <div class="theme-section" style="margin-bottom: unset; margin-top: unset">
    <div class="section-header d-flex justify-content-between align-items-center" style="padding: 0 15px">
      <h2 class="section-title">Merchant Portal Theming</h2>
      <div class="save-button-wrapper" (click)="saveTheme()">
        <span> Save</span>
      </div>
    </div>
    <div class="align-items-center d-flex py-2 justify-content-between" [style]="'background: #fff'">
      <div class="color-group" style="width: 319px; margin-left: 15px">
        <div
          class="color-control"
          [ngStyle]="{ 'pointer-events': advancedView ? 'none' : 'auto', opacity: advancedView ? 0.6 : 1 }"
          [style.pointer-events]="advancedView ? 'none' : 'auto'"
          style="margin-bottom: unset"
          (mouseenter)="!advancedView ? animateColor('primary') : null"
          (mouseleave)="stopAllAnimations()"
        >
          <span class="color-label font-bold">Primary Color</span>
          <div class="color-picker-wrapper">
            <div
              class="color-picker-input"
              [style.background]="theme.primary"
              [(colorPicker)]="theme.primary"
              [cpOKButton]="true"
              [cpOKButtonText]="'Select'"
              [cpWidth]="'180px'"
              [cpSaveClickOutside]="true"
              [cpCancelButton]="true"
              (colorPickerChange)="applyLiveColor(true)"
              (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
              (colorPickerClose)="this.isColorPickerOpened = false"
              [cpEyeDropper]="true"
              [cpPosition]="'bottom'"
              [cpDisableInput]="true"
              [cpPresetColors]="presetColors"
              [cpDisabled]="advancedView"
            ></div>
            <input
              type="text"
              class="color-value"
              [(ngModel)]="theme.primary"
              (click)="stopAllAnimations()"
              (input)="onHexColorInput($event, 'primary')"
              (keypress)="onHexColorKeyPress($event)"
              (paste)="onHexColorPaste($event)"
              maxlength="9"
              placeholder="#000000"
            />
          </div>
        </div>
      </div>

      <div class="advanced-toggle pr-5">
        <label class="toggle-label">Advanced View</label>
        <label class="switch">
          <input type="checkbox" [checked]="advancedView" (change)="changeView()" />
          <span class="slider"></span>
        </label>
      </div>
    </div>
  </div>
  <div style="height: 10px"></div>
</div>

<!-- Logos -->
<div class="theme-section" style="margin: 1.3rem auto auto auto">
  <div class="section-header">
    <h2 class="section-title">Logos & Favicon</h2>
  </div>
  <div *ngIf="showPendingImagesWarning">
    <div style="background: orange; padding: 8px; color: black; text-align: center">
      You have a logo pending our approval process, to expedite process please contact support, otherwise it will be
      approved within 24 hours.
    </div>
  </div>
  <div class="section-content" style="min-height: 355px">
    <div class="color-controls-panel">
      <div class="color-group">
        <h3 class="group-title">Images <span style="font-size: x-small"> - Accepted formats: PNG, JPG, JPEG</span></h3>
        <div
          class="color-control"
          id="fullLogoControl"
          (mouseenter)="startLogoAnimation()"
          (mouseleave)="stopLogoAnimation()"
        >
          <label class="color-label">Logo (200 x 70px)</label>
          <div class="logo-upload-wrapper">
            <input
              type="file"
              #fileInput
              accept="image/png, image/jpeg"
              (change)="onLogoUpload($event)"
              style="display: none"
            />

            <button type="button" class="upload-logo-btn" (click)="fileInput.click()">
              <i class="pi pi-upload"></i>
              {{ customLogoUploaded ? 'Change' : 'Choose File' }}
            </button>

            <button
              type="button"
              class="reset-logo-btn"
              (click)="resetLogo()"
              *ngIf="customLogoUploaded"
              title="Reset to default logo"
            >
              <i class="pi pi-refresh"></i>
              Reset
            </button>
          </div>
        </div>
        <div
          class="color-control"
          id="smallLogoControl"
          (mouseenter)="startSmallLogoAnimation()"
          (mouseleave)="stopSmallLogoAnimation()"
        >
          <label class="color-label">Small (60 x 70px)</label>
          <div class="logo-upload-wrapper">
            <input
              type="file"
              #reducedLogoInput
              accept="image/png, image/jpeg"
              (change)="onReducedLogoUpload($event)"
              style="display: none"
            />
            <button type="button" class="upload-logo-btn" (click)="reducedLogoInput.click()">
              <i class="pi pi-upload"></i>
              {{ customReducedLogoUploaded ? 'Change' : 'Choose File' }}
            </button>
            <button
              type="button"
              class="reset-logo-btn"
              (click)="resetReducedLogo()"
              *ngIf="customReducedLogoUploaded"
              title="Reset to default reduced logo"
            >
              <i class="pi pi-refresh"></i>
              Reset
            </button>
          </div>
        </div>
        <div
          class="color-control"
          id="faviconControl"
          (mouseenter)="startFaviconAnimation()"
          (mouseleave)="stopFaviconAnimation()"
        >
          <label class="color-label">Favicon (32 x 32px)</label>
          <div class="logo-upload-wrapper">
            <input
              type="file"
              #faviconInput
              accept="image/png,image/jpeg,.ico"
              (change)="onFaviconUpload($event)"
              style="display: none"
            />
            <button type="button" class="upload-logo-btn" (click)="faviconInput.click()">
              <i class="pi pi-upload"></i>
              {{ customFaviconUploaded ? 'Change' : 'Choose File' }}
            </button>
            <button
              type="button"
              class="reset-logo-btn"
              (click)="resetFavicon()"
              *ngIf="customFaviconUploaded"
              title="Reset to default favicon"
            >
              <i class="pi pi-refresh"></i>
              Reset
            </button>
          </div>
        </div>
        <div
          class="color-control"
          (mouseenter)="animateColor('sidebar.logoBackgroundColor')"
          (mouseleave)="stopAllAnimations()"
        >
          <label class="color-label">Background</label>
          <div class="color-picker-wrapper">
            <div
              class="color-picker-input"
              [style.background]="this.theme.sidebar.logoBackgroundColor"
              [(colorPicker)]="this.theme.sidebar.logoBackgroundColor"
              [cpOKButton]="true"
              [cpOKButtonText]="'Select'"
              [cpSaveClickOutside]="true"
              [cpCancelButton]="true"
              (colorPickerChange)="applyLiveColor()"
              [cpEyeDropper]="true"
              [cpPosition]="'bottom'"
              [cpWidth]="'180px'"
              [cpDisableInput]="true"
              [cpPresetColors]="presetColors"
              (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
              (colorPickerClose)="this.isColorPickerOpened = false"
            ></div>
            <input
              type="text"
              class="color-value"
              (click)="stopAllAnimations()"
              [(ngModel)]="this.theme.sidebar.logoBackgroundColor"
              (input)="onHexColorInput($event, 'sidebar.logoBackgroundColor')"
              (keypress)="onHexColorKeyPress($event)"
              (paste)="onHexColorPaste($event)"
              maxlength="9"
              placeholder="#000000"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6 mb-4 d-flex w-100 h-fit gap-8" style="zoom: 70%; pointer-events: none">
      <div class="side-navigation-bar">
        <div class="side-navigation-bar-header">
          <img [src]="getImageSrc()" alt="image" class="logo-image-full" [class.logo-animated]="logoAnimationActive" />
        </div>

        <div class="d-flex flex-column">
          <a class="nav-link activeMenu" routerLinkActive="true">
            <div class="nav-link-content">
              <span class="nav-label">Dashboard</span>
            </div>
          </a>
          <a class="nav-link" routerLinkActive="active" data-cy="nav-offers-mobile">
            <div class="nav-link-content">
              <span class="nav-label">Offers</span>
            </div>
          </a>
          <a class="nav-link" routerLinkActive="active">
            <div class="nav-link-content">
              <span class="nav-label">Members</span>
            </div>
          </a>
          <a class="nav-link" routerLinkActive="active">
            <div class="nav-link-content">
              <span class="nav-label">Transactions</span>
            </div>
          </a>
          <a class="nav-link" routerLinkActive="active">
            <div class="nav-link-content">
              <span class="nav-label">Reports</span>
            </div>
          </a>
        </div>

        <p-accordion [activeIndex]="0" [collapseIcon]="" [expandIcon]="">
          <p-accordionTab iconPos="end">
            <ng-template pTemplate="header">
              <div class="accordionNav">
                <div class="theme-text-color d-flex gap-3 ml-1">
                  <span class="theme-text-color ml-1"> Admin </span>
                </div>
              </div>
            </ng-template>
            <div class="d-flex flex-column">
              <a class="nav-link" routerLinkActive="active">
                <div class="nav-link-content">
                  <span class="nav-label">Locations</span>
                </div>
              </a>
            </div>
          </p-accordionTab>
        </p-accordion>
      </div>

      <div class="minimized-sidebar">
        <div class="side-navigation-bar">
          <div class="side-navigation-bar-header">
            <img
              [src]="getSmallImageSrc()"
              alt="image"
              class="logo-image"
              [class.logo-small-animated]="smallLogoAnimationActive"
            />
          </div>
          <!-- Your side navigation bar content here -->
          <nav class="nav">
            <a class="nav-link" routerLinkActive="active" [pTooltip]="'Dashboard'">
              <div class="nav-link-content">
                <fa-icon [icon]="icons['faHouse']" class="mr-3"></fa-icon>
                <span class="nav-label">Dashboard</span>
              </div>
            </a>
            <a class="nav-link" routerLinkActive="active" [pTooltip]="'Merchants'" data-cy="nav-merchants-mobile">
              <div class="nav-link-content">
                <fa-icon [icon]="icons['faStore']" class="mr-3"></fa-icon>
                <span class="nav-label">Merchants</span>
              </div>
            </a>
            <a class="nav-link" routerLinkActive="active" [pTooltip]="'Loyalty Program'">
              <div class="nav-link-content">
                <fa-icon [icon]="icons['faHandHoldingDollar']" class="mr-3"></fa-icon>
                <span class="nav-label">Loyalty Program</span>
              </div>
            </a>
            <a class="nav-link" routerLinkActive="active" [pTooltip]="'Billing'">
              <div class="nav-link-content">
                <fa-icon [icon]="icons['faEnvelope']" class="mr-3"></fa-icon>
                <span class="nav-label">Billing</span>
              </div>
            </a>
            <a class="nav-link" routerLinkActive="active" [pTooltip]="'Members'">
              <div class="nav-link-content">
                <fa-icon [icon]="icons['faUsers']" class="mr-3"></fa-icon>
                <span class="nav-label">Members</span>
              </div>
            </a>
            <a class="nav-link" routerLinkActive="active" [pTooltip]="'Admin'">
              <div class="nav-link-content">
                <fa-icon [icon]="icons['faGear']" class="mr-3"></fa-icon>
                <span class="nav-label">Admin</span>
              </div>
            </a>
          </nav>
        </div>
      </div>

      <div class="browser-tab-mock">
        <img
          [src]="getFaviconSrc()"
          alt="Favicon Preview"
          class="favicon-preview-image"
          [class.favicon-animated]="faviconAnimationActive"
        />
        <span>Enroll & Pay</span>
        <div class="pl-3"><span>&times;</span></div>
      </div>
    </div>
  </div>
</div>

<!-- Sidebar & Navigation -->
<div class="theme-section">
  <div class="section-header">
    <h2 class="section-title">Sidebar & Navigation</h2>
  </div>
  <div class="section-content align-items-center" style="min-height: 355px">
    <div class="color-controls-panel">
      <div class="color-group">
        <h3 class="group-title">Basic Colors</h3>
        <div
          class="color-control"
          (mouseenter)="animateColor('header.backgroundColor')"
          (mouseleave)="stopAllAnimations()"
        >
          <label class="color-label">Header Background</label>
          <div class="color-picker-wrapper">
            <div
              class="color-picker-input"
              [style.background]="theme.header.backgroundColor"
              [(colorPicker)]="theme.header.backgroundColor"
              [cpOKButton]="true"
              [cpOKButtonText]="'Select'"
              [cpSaveClickOutside]="true"
              [cpCancelButton]="true"
              (colorPickerChange)="applyLiveColor()"
              (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
              [cpEyeDropper]="true"
              [cpPosition]="'bottom'"
              [cpWidth]="'180px'"
              [cpDisableInput]="true"
              [cpPresetColors]="presetColors"
              (colorPickerClose)="this.isColorPickerOpened = false"
            ></div>
            <input
              type="text"
              class="color-value"
              (click)="stopAllAnimations()"
              [(ngModel)]="theme.header.backgroundColor"
              (input)="onHexColorInput($event, 'header.backgroundColor')"
              (keypress)="onHexColorKeyPress($event)"
              (paste)="onHexColorPaste($event)"
              maxlength="9"
              placeholder="#000000"
            />
          </div>
        </div>
        <div
          class="color-control"
          (mouseenter)="animateColor('sidebar.backgroundColor.primary')"
          (mouseleave)="stopAllAnimations()"
        >
          <label class="color-label">Sidebar Background</label>
          <div class="color-picker-wrapper">
            <div
              class="color-picker-input"
              [style.background]="theme.sidebar.backgroundColor.primary"
              [(colorPicker)]="theme.sidebar.backgroundColor.primary"
              [cpOKButton]="true"
              [cpOKButtonText]="'Select'"
              [cpSaveClickOutside]="true"
              [cpCancelButton]="true"
              [cpPositionRelativeToArrow]="false"
              (colorPickerChange)="applyLiveColor()"
              (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
              [cpEyeDropper]="true"
              [cpPosition]="'bottom'"
              [cpWidth]="'180px'"
              [cpDisableInput]="true"
              [cpPresetColors]="presetColors"
              (colorPickerClose)="this.isColorPickerOpened = false"
            ></div>
            <input
              type="text"
              class="color-value"
              (click)="stopAllAnimations()"
              [(ngModel)]="theme.sidebar.backgroundColor.primary"
              (input)="onHexColorInput($event, 'sidebar.backgroundColor.primary')"
              (keypress)="onHexColorKeyPress($event)"
              (paste)="onHexColorPaste($event)"
              maxlength="9"
              placeholder="#000000"
            />
          </div>
        </div>
        <div class="color-control" (mouseenter)="animateColor('backgroundColor')" (mouseleave)="stopAllAnimations()">
          <label class="color-label">Page Background</label>
          <div class="color-picker-wrapper">
            <div
              class="color-picker-input"
              [style.background]="theme.backgroundColor"
              [(colorPicker)]="theme.backgroundColor"
              [cpOKButton]="true"
              [cpOKButtonText]="'Select'"
              [cpSaveClickOutside]="true"
              [cpCancelButton]="true"
              [cpPositionRelativeToArrow]="false"
              (colorPickerChange)="applyLiveColor()"
              (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
              [cpEyeDropper]="true"
              [cpPosition]="'bottom'"
              [cpWidth]="'180px'"
              [cpDisableInput]="true"
              [cpPresetColors]="presetColors"
              (colorPickerClose)="this.isColorPickerOpened = false"
            ></div>
            <input
              type="text"
              class="color-value"
              (click)="stopAllAnimations()"
              [(ngModel)]="theme.backgroundColor"
              (input)="onHexColorInput($event, 'backgroundColor')"
              (keypress)="onHexColorKeyPress($event)"
              (paste)="onHexColorPaste($event)"
              maxlength="9"
              placeholder="#000000"
            />
          </div>
        </div>
        <div [class]="advancedView ? 'advanced-section show' : 'advanced-section'">
          <h3 class="group-title">Advanced Colors</h3>
          <div
            class="color-control"
            (mouseenter)="animateColor('sidebar.textColor')"
            (mouseleave)="stopAllAnimations()"
          >
            <label class="color-label">Text Color</label>
            <div class="color-picker-wrapper">
              <div
                class="color-picker-input"
                [style.background]="theme.sidebar.textColor"
                [(colorPicker)]="theme.sidebar.textColor"
                [cpOKButton]="true"
                [cpOKButtonText]="'Select'"
                [cpSaveClickOutside]="true"
                [cpCancelButton]="true"
                (colorPickerChange)="applyLiveColor()"
                (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
                [cpEyeDropper]="true"
                [cpPosition]="'bottom'"
                [cpWidth]="'180px'"
                [cpDisableInput]="true"
                [cpPresetColors]="presetColors"
                (colorPickerClose)="this.isColorPickerOpened = false"
              ></div>
              <input
                type="text"
                class="color-value"
                (click)="stopAllAnimations()"
                [(ngModel)]="theme.sidebar.textColor"
                (input)="onHexColorInput($event, 'sidebar.textColor')"
                (keypress)="onHexColorKeyPress($event)"
                (paste)="onHexColorPaste($event)"
                maxlength="9"
                placeholder="#000000"
              />
            </div>
          </div>
          <div
            class="color-control"
            (mouseenter)="animateColor('sidebar.backgroundColor.active')"
            (mouseleave)="stopAllAnimations()"
          >
            <label class="color-label">Active Page Indicator</label>
            <div class="color-picker-wrapper">
              <div
                class="color-picker-input"
                [style.background]="theme.sidebar.backgroundColor.active"
                [(colorPicker)]="theme.sidebar.backgroundColor.active"
                [cpOKButton]="true"
                [cpOKButtonText]="'Select'"
                [cpSaveClickOutside]="true"
                [cpCancelButton]="true"
                (colorPickerChange)="applyLiveColor()"
                (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
                [cpEyeDropper]="true"
                [cpPosition]="'right'"
                [cpWidth]="'180px'"
                [cpDisableInput]="true"
                [cpPresetColors]="presetColors"
                (colorPickerClose)="this.isColorPickerOpened = false"
              ></div>
              <input
                type="text"
                class="color-value"
                (click)="stopAllAnimations()"
                [(ngModel)]="theme.sidebar.backgroundColor.active"
                (input)="onHexColorInput($event, 'sidebar.backgroundColor.active')"
                (keypress)="onHexColorKeyPress($event)"
                (paste)="onHexColorPaste($event)"
                maxlength="9"
                placeholder="#000000"
              />
            </div>
          </div>
          <div
            class="color-control"
            (mouseenter)="animateColor('sidebar.backgroundColor.dropdown')"
            (mouseleave)="stopAllAnimations()"
          >
            <label class="color-label">Expanding Indicator</label>
            <div class="color-picker-wrapper">
              <div
                class="color-picker-input"
                [style.background]="theme.sidebar.backgroundColor.dropdown"
                [(colorPicker)]="theme.sidebar.backgroundColor.dropdown"
                [cpOKButton]="true"
                [cpOKButtonText]="'Select'"
                [cpSaveClickOutside]="true"
                [cpCancelButton]="true"
                (colorPickerChange)="applyLiveColor()"
                (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
                [cpEyeDropper]="true"
                [cpPosition]="'right'"
                [cpWidth]="'180px'"
                [cpDisableInput]="true"
                [cpPresetColors]="presetColors"
                (colorPickerClose)="this.isColorPickerOpened = false"
              ></div>
              <input
                type="text"
                class="color-value"
                (click)="stopAllAnimations()"
                [(ngModel)]="theme.sidebar.backgroundColor.dropdown"
                (input)="onHexColorInput($event, 'sidebar.backgroundColor.dropdown')"
                (keypress)="onHexColorKeyPress($event)"
                (paste)="onHexColorPaste($event)"
                maxlength="9"
                placeholder="#000000"
              />
            </div>
          </div>
          <div
            class="color-control"
            (mouseenter)="animateColor('sidebar.backgroundColor.secondary')"
            (mouseleave)="stopAllAnimations()"
          >
            <label class="color-label">Hover State</label>
            <div class="color-picker-wrapper">
              <div
                class="color-picker-input"
                [style.background]="theme.sidebar.backgroundColor.secondary"
                [(colorPicker)]="theme.sidebar.backgroundColor.secondary"
                [cpOKButton]="true"
                [cpOKButtonText]="'Select'"
                [cpSaveClickOutside]="true"
                [cpCancelButton]="true"
                (colorPickerChange)="applyLiveColor()"
                (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
                [cpEyeDropper]="true"
                [cpPosition]="'right'"
                [cpWidth]="'180px'"
                [cpDisableInput]="true"
                [cpPresetColors]="presetColors"
                (colorPickerClose)="this.isColorPickerOpened = false"
              ></div>
              <input
                type="text"
                class="color-value"
                (click)="stopAllAnimations()"
                [(ngModel)]="theme.sidebar.backgroundColor.secondary"
                (input)="onHexColorInput($event, 'sidebar.backgroundColor.secondary')"
                (keypress)="onHexColorKeyPress($event)"
                (paste)="onHexColorPaste($event)"
                maxlength="9"
                placeholder="#000000"
              />
            </div>
          </div>
          <div
            class="color-control"
            (mouseenter)="animateColor('header.itemsColor')"
            (mouseleave)="stopAllAnimations()"
          >
            <label class="color-label">Buttons</label>
            <div class="color-picker-wrapper">
              <div
                class="color-picker-input"
                [style.background]="theme.header.itemsColor"
                [(colorPicker)]="theme.header.itemsColor"
                [cpOKButton]="true"
                [cpOKButtonText]="'Select'"
                [cpSaveClickOutside]="true"
                [cpCancelButton]="true"
                (colorPickerChange)="applyLiveColor()"
                (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
                [cpEyeDropper]="true"
                [cpPosition]="'bottom'"
                [cpWidth]="'180px'"
                [cpDisableInput]="true"
                [cpPresetColors]="presetColors"
                (colorPickerClose)="this.isColorPickerOpened = false"
              ></div>
              <input
                type="text"
                class="color-value"
                (click)="stopAllAnimations()"
                [(ngModel)]="theme.header.itemsColor"
                (input)="onHexColorInput($event, 'header.itemsColor')"
                (keypress)="onHexColorKeyPress($event)"
                (paste)="onHexColorPaste($event)"
                maxlength="9"
                placeholder="#000000"
              />
            </div>
          </div>
          <div class="color-control" (mouseenter)="animateColor('header.textColor')" (mouseleave)="stopAllAnimations()">
            <label class="color-label">Button Text</label>
            <div class="color-picker-wrapper">
              <div
                class="color-picker-input"
                [style.background]="theme.header.textColor"
                [(colorPicker)]="theme.header.textColor"
                [cpOKButton]="true"
                [cpOKButtonText]="'Select'"
                [cpSaveClickOutside]="true"
                [cpCancelButton]="true"
                (colorPickerChange)="applyLiveColor()"
                (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
                [cpEyeDropper]="true"
                [cpPosition]="'bottom'"
                [cpWidth]="'180px'"
                [cpDisableInput]="true"
                [cpPresetColors]="presetColors"
                (colorPickerClose)="this.isColorPickerOpened = false"
              ></div>
              <input
                type="text"
                class="color-value"
                (click)="stopAllAnimations()"
                [(ngModel)]="theme.header.textColor"
                (input)="onHexColorInput($event, 'header.textColor')"
                (keypress)="onHexColorKeyPress($event)"
                (paste)="onHexColorPaste($event)"
                maxlength="9"
                placeholder="#000000"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6 mb-4 d-flex w-100 h-fit" style="zoom: 70%">
      <div class="side-navigation-bar">
        <div class="side-navigation-bar-header">
          <img [src]="getImageSrc()" alt="image" class="logo-image-full" [class.logo-animated]="logoAnimationActive" />
        </div>
        <div class="d-flex flex-column">
          <a class="nav-link activeMenu" routerLinkActive="true">
            <div class="nav-link-content">
              <span class="nav-label">Dashboard</span>
            </div>
          </a>
          <a class="nav-link" routerLinkActive="active" data-cy="nav-offers-mobile">
            <div class="nav-link-content">
              <span class="nav-label">Offers</span>
            </div>
          </a>
          <a class="nav-link" routerLinkActive="active">
            <div class="nav-link-content">
              <span class="nav-label">Members</span>
            </div>
          </a>
          <a class="nav-link" routerLinkActive="active">
            <div class="nav-link-content">
              <span class="nav-label">Transactions</span>
            </div>
          </a>
          <a class="nav-link" routerLinkActive="active">
            <div class="nav-link-content">
              <span class="nav-label">Reports</span>
            </div>
          </a>
        </div>
        <p-accordion [activeIndex]="0" [collapseIcon]="" [expandIcon]="" [style]="{ 'pointer-events': 'none' }">
          <p-accordionTab iconPos="end">
            <ng-template pTemplate="header">
              <div class="accordionNav">
                <div class="theme-text-color d-flex gap-3 ml-1">
                  <span class="theme-text-color ml-1"> Admin </span>
                </div>
              </div>
            </ng-template>
            <div class="d-flex flex-column">
              <a class="nav-link" routerLinkActive="active">
                <div class="nav-link-content">
                  <span class="nav-label">Locations</span>
                </div>
              </a>
            </div>
          </p-accordionTab>
        </p-accordion>
      </div>

      <div class="d-flex flex-column w-100">
        <div class="header-wrapper w-100">
          <fa-icon [icon]="icons['faBars']" class="header-icon" />
          <div>
            <button
              #btn
              type="button"
              pButton
              icon="pi pi-angle-down"
              label="Enroll & Pay"
              class="header-item"
              (click)="menu.toggle($event)"
              data-cy="merchant-header-dropdown"
            ></button>
            <p-tieredMenu
              #menu
              [popup]="true"
              [style]="{ background: 'var(--sidebar-bg-primary, #f8f9fa)' }"
            ></p-tieredMenu>
          </div>
        </div>

        <div class="h-100 main-content"></div>
      </div>
    </div>
  </div>
</div>

<!-- Dashboard -->
<div class="theme-section form-section">
  <div class="section-header">
    <h2 class="section-title">Dashboard</h2>
  </div>
  <div class="section-content align-items-center">
    <!-- Dashboard Color Controls -->
    <div class="color-controls-panel">
      <div class="color-group">
        <h3 class="group-title">Cards Colors</h3>
        <div class="color-control" (mouseenter)="animateColor('dashboard.sales')" (mouseleave)="stopAllAnimations()">
          <label class="color-label">Sales</label>
          <div class="color-picker-wrapper">
            <div
              class="color-picker-input"
              [style.background]="theme.dashboard.sales"
              [(colorPicker)]="theme.dashboard.sales"
              [cpOKButton]="true"
              [cpOKButtonText]="'Select'"
              [cpSaveClickOutside]="true"
              [cpCancelButton]="true"
              (colorPickerChange)="applyLiveColor()"
              (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
              [cpEyeDropper]="true"
              [cpPosition]="'right'"
              [cpWidth]="'180px'"
              [cpDisableInput]="true"
              [cpPresetColors]="presetColors"
              (colorPickerClose)="this.isColorPickerOpened = false"
            ></div>
            <input
              type="text"
              class="color-value"
              (click)="stopAllAnimations()"
              [(ngModel)]="theme.dashboard.sales"
              (input)="onHexColorInput($event, 'dashboard.sales')"
              (keypress)="onHexColorKeyPress($event)"
              (paste)="onHexColorPaste($event)"
              maxlength="9"
              placeholder="#00000000"
            />
          </div>
        </div>
        <div class="color-control" (mouseenter)="animateColor('dashboard.loyalty')" (mouseleave)="stopAllAnimations()">
          <label class="color-label">Loyalty</label>
          <div class="color-picker-wrapper">
            <div
              class="color-picker-input"
              [style.background]="theme.dashboard.loyalty"
              [(colorPicker)]="theme.dashboard.loyalty"
              [cpOKButton]="true"
              [cpOKButtonText]="'Select'"
              [cpSaveClickOutside]="true"
              [cpCancelButton]="true"
              (colorPickerChange)="applyLiveColor()"
              (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
              [cpEyeDropper]="true"
              [cpPosition]="'right'"
              [cpWidth]="'180px'"
              [cpDisableInput]="true"
              [cpPresetColors]="presetColors"
              (colorPickerClose)="this.isColorPickerOpened = false"
            ></div>
            <input
              type="text"
              class="color-value"
              (click)="stopAllAnimations()"
              [(ngModel)]="theme.dashboard.loyalty"
              (input)="onHexColorInput($event, 'dashboard.loyalty')"
              (keypress)="onHexColorKeyPress($event)"
              (paste)="onHexColorPaste($event)"
              maxlength="9"
              placeholder="#000000"
            />
          </div>
        </div>
        <div class="color-control" (mouseenter)="animateColor('dashboard.rewards')" (mouseleave)="stopAllAnimations()">
          <label class="color-label">Rewards</label>
          <div class="color-picker-wrapper">
            <div
              class="color-picker-input"
              [style.background]="theme.dashboard.rewards"
              [(colorPicker)]="theme.dashboard.rewards"
              [cpOKButton]="true"
              [cpOKButtonText]="'Select'"
              [cpSaveClickOutside]="true"
              [cpCancelButton]="true"
              (colorPickerChange)="applyLiveColor()"
              (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
              [cpEyeDropper]="true"
              [cpPosition]="'right'"
              [cpWidth]="'180px'"
              [cpDisableInput]="true"
              [cpPresetColors]="presetColors"
              (colorPickerClose)="this.isColorPickerOpened = false"
            ></div>
            <input
              type="text"
              class="color-value"
              (click)="stopAllAnimations()"
              [(ngModel)]="theme.dashboard.rewards"
              (input)="onHexColorInput($event, 'dashboard.rewards')"
              (keypress)="onHexColorKeyPress($event)"
              (paste)="onHexColorPaste($event)"
              maxlength="9"
              placeholder="#000000"
            />
          </div>
        </div>
        <div class="color-control" (mouseenter)="animateColor('dashboard.reviews')" (mouseleave)="stopAllAnimations()">
          <label class="color-label">Reviews</label>
          <div class="color-picker-wrapper">
            <div
              class="color-picker-input"
              [style.background]="theme.dashboard.reviews"
              [(colorPicker)]="theme.dashboard.reviews"
              [cpOKButton]="true"
              [cpOKButtonText]="'Select'"
              [cpSaveClickOutside]="true"
              [cpCancelButton]="true"
              (colorPickerChange)="applyLiveColor()"
              (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
              [cpEyeDropper]="true"
              [cpPosition]="'right'"
              [cpWidth]="'180px'"
              [cpDisableInput]="true"
              [cpPresetColors]="presetColors"
              (colorPickerClose)="this.isColorPickerOpened = false"
            ></div>
            <input
              type="text"
              class="color-value"
              (click)="stopAllAnimations()"
              [(ngModel)]="theme.dashboard.reviews"
              (input)="onHexColorInput($event, 'dashboard.reviews')"
              (keypress)="onHexColorKeyPress($event)"
              (paste)="onHexColorPaste($event)"
              maxlength="9"
              placeholder="#000000"
            />
          </div>
        </div>
        <div
          class="color-control"
          [class.advanced-controls]="true"
          [style.display]="advancedView ? 'flex' : 'none'"
          (mouseenter)="animateColor('dashboard.coloredCardTextColor')"
          (mouseleave)="stopAllAnimations()"
        >
          <label class="color-label">Text Color</label>
          <div class="color-picker-wrapper">
            <div
              class="color-picker-input"
              [style.background]="theme.dashboard.coloredCardTextColor"
              [(colorPicker)]="theme.dashboard.coloredCardTextColor"
              [cpOKButton]="true"
              [cpOKButtonText]="'Select'"
              [cpSaveClickOutside]="true"
              [cpCancelButton]="true"
              (colorPickerChange)="applyLiveColor()"
              (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
              [cpEyeDropper]="true"
              [cpPosition]="'right'"
              [cpWidth]="'180px'"
              [cpDisableInput]="true"
              [cpPresetColors]="presetColors"
              (colorPickerClose)="this.isColorPickerOpened = false"
            ></div>
            <input
              type="text"
              class="color-value"
              (click)="stopAllAnimations()"
              [(ngModel)]="theme.dashboard.coloredCardTextColor"
              (input)="onHexColorInput($event, 'dashboard.coloredCardTextColor')"
              (keypress)="onHexColorKeyPress($event)"
              (paste)="onHexColorPaste($event)"
              maxlength="9"
              placeholder="#000000"
            />
          </div>
        </div>
        <div
          class="color-control"
          (mouseenter)="animateColor('dashboard.headerBackgroundColor')"
          (mouseleave)="stopAllAnimations()"
        >
          <label class="color-label">Header Background</label>
          <div class="color-picker-wrapper">
            <div
              class="color-picker-input"
              [style.background]="theme.dashboard.headerBackgroundColor"
              [(colorPicker)]="theme.dashboard.headerBackgroundColor"
              [cpOKButton]="true"
              [cpOKButtonText]="'Select'"
              [cpSaveClickOutside]="true"
              [cpCancelButton]="true"
              (colorPickerChange)="applyLiveColor()"
              (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
              [cpEyeDropper]="true"
              [cpPosition]="'right'"
              [cpWidth]="'180px'"
              [cpDisableInput]="true"
              [cpPresetColors]="presetColors"
              (colorPickerClose)="this.isColorPickerOpened = false"
            ></div>
            <input
              type="text"
              class="color-value"
              (click)="stopAllAnimations()"
              [(ngModel)]="theme.dashboard.headerBackgroundColor"
              (input)="onHexColorInput($event, 'dashboard.headerBackgroundColor')"
              (keypress)="onHexColorKeyPress($event)"
              (paste)="onHexColorPaste($event)"
              maxlength="9"
              placeholder="#000000"
            />
          </div>
        </div>
        <div
          class="color-control"
          [class.advanced-controls]="true"
          [style.display]="advancedView ? 'flex' : 'none'"
          (mouseenter)="animateColor('dashboard.headerTextColor')"
          (mouseleave)="stopAllAnimations()"
        >
          <label class="color-label">Header Text</label>
          <div class="color-picker-wrapper">
            <div
              class="color-picker-input"
              [style.background]="theme.dashboard.headerTextColor"
              [(colorPicker)]="theme.dashboard.headerTextColor"
              [cpOKButton]="true"
              [cpOKButtonText]="'Select'"
              [cpSaveClickOutside]="true"
              [cpCancelButton]="true"
              (colorPickerChange)="applyLiveColor()"
              (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
              [cpEyeDropper]="true"
              [cpPosition]="'right'"
              [cpWidth]="'180px'"
              [cpDisableInput]="true"
              [cpPresetColors]="presetColors"
              (colorPickerClose)="this.isColorPickerOpened = false"
            ></div>
            <input
              type="text"
              class="color-value"
              (click)="stopAllAnimations()"
              [(ngModel)]="theme.dashboard.headerTextColor"
              (input)="onHexColorInput($event, 'dashboard.headerTextColor')"
              (keypress)="onHexColorKeyPress($event)"
              (paste)="onHexColorPaste($event)"
              maxlength="9"
              placeholder="#000000"
            />
          </div>
        </div>
        <div [class]="advancedView ? 'advanced-section show' : 'advanced-section'">
          <h3 class="group-title">Sub Card</h3>
          <div
            class="color-control"
            (mouseenter)="animateColor('dashboard.cardBackgroundColor')"
            (mouseleave)="stopAllAnimations()"
          >
            <label class="color-label">Card Background</label>
            <div class="color-picker-wrapper">
              <div
                class="color-picker-input"
                [style.background]="theme.dashboard.cardBackgroundColor"
                [(colorPicker)]="theme.dashboard.cardBackgroundColor"
                [cpOKButton]="true"
                [cpOKButtonText]="'Select'"
                [cpSaveClickOutside]="true"
                [cpCancelButton]="true"
                (colorPickerChange)="applyLiveColor()"
                (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
                [cpEyeDropper]="true"
                [cpPosition]="'top'"
                [cpWidth]="'180px'"
                [cpDisableInput]="true"
                [cpPresetColors]="presetColors"
                (colorPickerClose)="this.isColorPickerOpened = false"
              ></div>
              <input
                type="text"
                class="color-value"
                (click)="stopAllAnimations()"
                [(ngModel)]="theme.dashboard.cardBackgroundColor"
                (input)="onHexColorInput($event, 'dashboard.cardBackgroundColor')"
                (keypress)="onHexColorKeyPress($event)"
                (paste)="onHexColorPaste($event)"
                maxlength="9"
                placeholder="#000000"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Dashboard Component -->
    <div class="dashboard-preview">
      <div class="full-width">
        <p-tabView>
          <p-tabPanel header="TODAY">
            <ng-template pTemplate="content"> </ng-template>
          </p-tabPanel>
          <p-tabPanel header="WEEK">
            <ng-template pTemplate="content"> </ng-template>
          </p-tabPanel>
          <p-tabPanel header="MONTH">
            <ng-template pTemplate="content"> </ng-template>
          </p-tabPanel>
          <p-tabPanel header="CUSTOM">
            <ng-template pTemplate="content"> </ng-template>
          </p-tabPanel>
        </p-tabView>
      </div>
      <div class="loyalty-overview-panel-column-data">
        <div class="loyalty-overview-panel-row-data">
          <ep-view-card class="loyalty-panel-data" [config]="configs[0]"></ep-view-card>
          <ep-view-card class="loyalty-panel-data" [config]="configs[1]"></ep-view-card>
        </div>
        <div class="loyalty-overview-panel-row-data">
          <ep-view-card class="loyalty-panel-data" [config]="configs[2]"></ep-view-card>
          <ep-view-card class="loyalty-panel-data" [config]="configs[3]"></ep-view-card>
        </div>
      </div>
      <div class="dashboard-overview-panel-wrapper mt-2">
        <p-panel>
          <ng-template pTemplate="header">
            <div class="panel-header-wrapper">
              <i class="bi bi-bar-chart" style="font-size: 20px"></i>
              <span class="panel-header"> SALES OVERVIEW</span>
            </div>
          </ng-template>

          <div class="overview-panel-column-data">
            <div class="overview-panel-row-data">
              <div class="dashboard-overview-panel-data">
                <div class="dashboard-overview-panel-data-wrapper">
                  <span [style]="{ color: overviews[0].headerColor }" class="font-medium">
                    {{ overviews[0].header }}
                  </span>
                  <span [style]="{ color: overviews[0].subHeaderColor }"> {{ overviews[0].subHeader }} </span>
                  <div>
                    <span
                      class="overview-panel-body text-overflow sales-overview-01"
                      [style]="{ color: overviews[0].bodyColor }"
                      >{{ overviews[0].body }}</span
                    >
                    <span>{{ overviews[0].subBody }}</span>
                  </div>
                  <span [style]="{ color: overviews[0].footerColor }"> {{ overviews[0].footer }} </span>
                  <span [style]="{ color: overviews[0].subFooter }"> {{ overviews[0].subFooter }} </span>
                </div>
              </div>
              <div class="dashboard-overview-panel-data">
                <div class="dashboard-overview-panel-data-wrapper">
                  <span [style]="{ color: overviews[1].headerColor }" class="font-medium">
                    {{ overviews[1].header }}
                  </span>
                  <span [style]="{ color: overviews[1].subHeaderColor }"> {{ overviews[1].subHeader }} </span>
                  <div>
                    <span
                      class="overview-panel-body text-overflow sales-overview-02"
                      [style]="{ color: overviews[1].bodyColor }"
                      >{{ overviews[1].body }}</span
                    >
                    <span>{{ overviews[1].subBody }}</span>
                  </div>
                  <span [style]="{ color: overviews[1].footerColor }"> {{ overviews[1].footer }} </span>
                  <span [style]="{ color: overviews[1].subFooter }"> {{ overviews[1].subFooter }} </span>
                </div>
              </div>
              <div class="dashboard-overview-panel-data">
                <div class="dashboard-overview-panel-data-wrapper">
                  <span [style]="{ color: overviews[2].headerColor }" class="font-medium">
                    {{ overviews[2].header }}
                  </span>
                  <span [style]="{ color: overviews[2].subHeaderColor }"> {{ overviews[2].subHeader }} </span>
                  <div>
                    <span
                      class="overview-panel-body text-overflow sales-overview-03"
                      [style]="{ color: overviews[2].bodyColor }"
                      >{{ overviews[2].body }}</span
                    >
                    <span>{{ overviews[2].subBody }}</span>
                  </div>
                  <span [style]="{ color: overviews[2].footerColor }"> {{ overviews[2].footer }} </span>
                  <span [style]="{ color: overviews[2].subFooter }"> {{ overviews[2].subFooter }} </span>
                </div>
              </div>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
  </div>
</div>

<!-- Table Section -->
<div class="theme-section table-section">
  <div class="section-header">
    <h2 class="section-title">Data Tables</h2>
  </div>

  <div class="section-content align-items-center">
    <!-- Table Color Controls -->
    <div class="color-controls-panel">
      <div class="color-group">
        <h3 class="group-title">Table Body</h3>
        <div
          class="color-control"
          (mouseenter)="animateColor('table.body.primaryBackgroundColor')"
          (mouseleave)="stopAllAnimations()"
        >
          <label class="color-label">Primary Row</label>
          <div class="color-picker-wrapper">
            <div
              class="color-picker-input"
              [(colorPicker)]="theme.table.body.primaryBackgroundColor"
              [style.background]="theme.table.body.primaryBackgroundColor"
              [cpOKButton]="true"
              [cpOKButtonText]="'Select'"
              [cpSaveClickOutside]="true"
              [cpCancelButton]="true"
              (colorPickerChange)="applyLiveColor()"
              (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
              [cpEyeDropper]="true"
              [cpPosition]="'bottom'"
              [cpWidth]="'180px'"
              [cpDisableInput]="true"
              [cpPresetColors]="presetColors"
              (colorPickerClose)="this.isColorPickerOpened = false"
            ></div>
            <input
              type="text"
              class="color-value"
              (click)="stopAllAnimations()"
              [(ngModel)]="theme.table.body.primaryBackgroundColor"
              (input)="onHexColorInput($event, 'table.body.primaryBackgroundColor')"
              (keypress)="onHexColorKeyPress($event)"
              (paste)="onHexColorPaste($event)"
              maxlength="9"
              placeholder="#000000"
            />
          </div>
        </div>
        <div
          class="color-control"
          (mouseenter)="animateColor('table.body.secondaryBackgroundColor')"
          (mouseleave)="stopAllAnimations()"
        >
          <label class="color-label">Alternate Row</label>
          <div class="color-picker-wrapper">
            <div
              class="color-picker-input"
              [(colorPicker)]="theme.table.body.secondaryBackgroundColor"
              [style.background]="theme.table.body.secondaryBackgroundColor"
              [cpOKButton]="true"
              [cpOKButtonText]="'Select'"
              [cpSaveClickOutside]="true"
              [cpCancelButton]="true"
              (colorPickerChange)="applyLiveColor()"
              (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
              [cpEyeDropper]="true"
              [cpPosition]="'bottom'"
              [cpWidth]="'180px'"
              [cpDisableInput]="true"
              [cpPresetColors]="presetColors"
              (colorPickerClose)="this.isColorPickerOpened = false"
            ></div>
            <input
              type="text"
              class="color-value"
              (click)="stopAllAnimations()"
              [(ngModel)]="theme.table.body.secondaryBackgroundColor"
              (input)="onHexColorInput($event, 'table.body.secondaryBackgroundColor')"
              (keypress)="onHexColorKeyPress($event)"
              (paste)="onHexColorPaste($event)"
              maxlength="9"
              placeholder="#000000"
            />
          </div>
        </div>
        <div
          class="color-control"
          [class.advanced-controls]="true"
          [style.display]="advancedView ? 'flex' : 'none'"
          (mouseenter)="animateColor('table.body.textColor')"
          (mouseleave)="stopAllAnimations()"
        >
          <label class="color-label">Body Text</label>
          <div class="color-picker-wrapper">
            <div
              class="color-picker-input"
              [(colorPicker)]="theme.table.body.textColor"
              [style.background]="theme.table.body.textColor"
              [cpOKButton]="true"
              [cpOKButtonText]="'Select'"
              [cpSaveClickOutside]="true"
              [cpCancelButton]="true"
              (colorPickerChange)="applyLiveColor()"
              (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
              [cpEyeDropper]="true"
              [cpPosition]="'bottom'"
              [cpWidth]="'180px'"
              [cpDisableInput]="true"
              [cpPresetColors]="presetColors"
              (colorPickerClose)="this.isColorPickerOpened = false"
            ></div>
            <input
              type="text"
              class="color-value"
              (click)="stopAllAnimations()"
              [(ngModel)]="theme.table.body.textColor"
              (input)="onHexColorInput($event, 'table.body.textColor')"
              (keypress)="onHexColorKeyPress($event)"
              (paste)="onHexColorPaste($event)"
              maxlength="9"
              placeholder="#000000"
            />
          </div>
        </div>
        <div [class]="advancedView ? 'advanced-section show' : 'advanced-section'">
          <h3 class="group-title">Header</h3>
          <div
            class="color-control"
            (mouseenter)="animateColor('table.header.backgroundColor')"
            (mouseleave)="stopAllAnimations()"
          >
            <label class="color-label">Header Background</label>
            <div class="color-picker-wrapper">
              <div
                class="color-picker-input"
                [style.background]="theme.table.header.backgroundColor"
                [(colorPicker)]="theme.table.header.backgroundColor"
                [cpOKButton]="true"
                [cpOKButtonText]="'Select'"
                [cpSaveClickOutside]="true"
                [cpCancelButton]="true"
                (colorPickerChange)="applyLiveColor()"
                (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
                [cpEyeDropper]="true"
                [cpPosition]="'bottom'"
                [cpWidth]="'180px'"
                [cpDisableInput]="true"
                [cpPresetColors]="presetColors"
                (colorPickerClose)="this.isColorPickerOpened = false"
              ></div>
              <input
                type="text"
                class="color-value"
                (click)="stopAllAnimations()"
                [(ngModel)]="theme.table.header.backgroundColor"
                (input)="onHexColorInput($event, 'table.header.backgroundColor')"
                (keypress)="onHexColorKeyPress($event)"
                (paste)="onHexColorPaste($event)"
                maxlength="9"
                placeholder="#000000"
              />
            </div>
          </div>
          <div
            class="color-control"
            (mouseenter)="animateColor('table.header.textColor')"
            (mouseleave)="stopAllAnimations()"
          >
            <label class="color-label">Header Text</label>
            <div class="color-picker-wrapper">
              <div
                class="color-picker-input"
                [style.background]="theme.table.header.textColor"
                [(colorPicker)]="theme.table.header.textColor"
                [cpOKButton]="true"
                [cpOKButtonText]="'Select'"
                [cpSaveClickOutside]="true"
                [cpCancelButton]="true"
                (colorPickerChange)="applyLiveColor()"
                (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
                [cpEyeDropper]="true"
                [cpPosition]="'bottom'"
                [cpWidth]="'180px'"
                [cpDisableInput]="true"
                [cpPresetColors]="presetColors"
                (colorPickerClose)="this.isColorPickerOpened = false"
              ></div>
              <input
                type="text"
                class="color-value"
                (click)="stopAllAnimations()"
                [(ngModel)]="theme.table.header.textColor"
                (input)="onHexColorInput($event, 'table.header.textColor')"
                (keypress)="onHexColorKeyPress($event)"
                (paste)="onHexColorPaste($event)"
                maxlength="9"
                placeholder="#000000"
              />
            </div>
          </div>
          <h3 class="group-title">Sub Header & Footer</h3>
          <div
            class="color-control"
            (mouseenter)="animateColor('table.subHeaderBackgroundColor')"
            (mouseleave)="stopAllAnimations()"
          >
            <label class="color-label">Background</label>
            <div class="color-picker-wrapper">
              <div
                class="color-picker-input"
                [(colorPicker)]="theme.table.subHeaderBackgroundColor"
                [style.background]="theme.table.subHeaderBackgroundColor"
                [cpOKButton]="true"
                [cpOKButtonText]="'Select'"
                [cpSaveClickOutside]="true"
                [cpCancelButton]="true"
                (colorPickerChange)="applyLiveColor()"
                (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
                [cpEyeDropper]="true"
                [cpPosition]="'bottom'"
                [cpWidth]="'180px'"
                [cpDisableInput]="true"
                [cpPresetColors]="presetColors"
                (colorPickerClose)="this.isColorPickerOpened = false"
              ></div>
              <input
                type="text"
                class="color-value"
                (click)="stopAllAnimations()"
                [(ngModel)]="theme.table.subHeaderBackgroundColor"
                (input)="onHexColorInput($event, 'table.subHeaderBackgroundColor')"
                (keypress)="onHexColorKeyPress($event)"
                (paste)="onHexColorPaste($event)"
                maxlength="9"
                placeholder="#000000"
              />
            </div>
          </div>
          <div
            class="color-control"
            [class.advanced-controls]="true"
            [style.display]="advancedView ? 'flex' : 'none'"
            (mouseenter)="animateColor('table.subHeaderTextColor')"
            (mouseleave)="stopAllAnimations()"
          >
            <label class="color-label">Text Color</label>
            <div class="color-picker-wrapper">
              <div
                class="color-picker-input"
                [(colorPicker)]="theme.table.subHeaderTextColor"
                [style.background]="theme.table.subHeaderTextColor"
                [cpOKButton]="true"
                [cpOKButtonText]="'Select'"
                [cpSaveClickOutside]="true"
                [cpCancelButton]="true"
                (colorPickerChange)="applyLiveColor()"
                (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
                [cpEyeDropper]="true"
                [cpPosition]="'bottom'"
                [cpWidth]="'180px'"
                [cpDisableInput]="true"
                [cpPresetColors]="presetColors"
                (colorPickerClose)="this.isColorPickerOpened = false"
              ></div>
              <input
                type="text"
                class="color-value"
                (click)="stopAllAnimations()"
                [(ngModel)]="theme.table.subHeaderTextColor"
                (input)="onHexColorInput($event, 'table.subHeaderTextColor')"
                (keypress)="onHexColorKeyPress($event)"
                (paste)="onHexColorPaste($event)"
                maxlength="9"
                placeholder="#000000"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Table Preview Component -->
    <div class="table-preview">
      <app-ep-table [config]="config" [data]="data" data-cy="members-table" />
    </div>
  </div>
</div>

<!-- Form Section -->
<div class="theme-section form-section" data-section="form-section">
  <div class="section-header">
    <h2 class="section-title">Forms & Cards</h2>
  </div>
  <div class="section-content align-items-center">
    <!-- Form Color Controls -->
    <div class="color-controls-panel">
      <div class="color-group">
        <h3 class="group-title">Form Body</h3>
        <div
          class="color-control"
          (mouseenter)="animateColor('form.backgroundColor')"
          (mouseleave)="stopAllAnimations()"
        >
          <label class="color-label">Background</label>
          <div class="color-picker-wrapper">
            <div
              class="color-picker-input"
              [style.background]="theme.form.backgroundColor"
              [(colorPicker)]="theme.form.backgroundColor"
              [cpOKButton]="true"
              [cpOKButtonText]="'Select'"
              [cpSaveClickOutside]="true"
              [cpCancelButton]="true"
              (colorPickerChange)="applyLiveColor()"
              (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
              [cpEyeDropper]="true"
              [cpPosition]="'top'"
              [cpWidth]="'180px'"
              [cpDisableInput]="true"
              [cpPresetColors]="presetColors"
              (colorPickerClose)="this.isColorPickerOpened = false"
            ></div>
            <input
              type="text"
              class="color-value"
              (click)="stopAllAnimations()"
              [(ngModel)]="theme.form.backgroundColor"
              (input)="onHexColorInput($event, 'form.backgroundColor')"
              (keypress)="onHexColorKeyPress($event)"
              (paste)="onHexColorPaste($event)"
              maxlength="9"
              placeholder="#000000"
            />
          </div>
        </div>
        <div [class]="advancedView ? 'advanced-section show' : 'advanced-section'">
          <div class="color-control" (mouseenter)="animateColor('defaultTextColor')" (mouseleave)="stopAllAnimations()">
            <label class="color-label">Text Color</label>
            <div class="color-picker-wrapper">
              <div
                class="color-picker-input"
                [style.background]="theme.defaultTextColor"
                [(colorPicker)]="theme.defaultTextColor"
                [cpOKButton]="true"
                [cpOKButtonText]="'Select'"
                [cpSaveClickOutside]="true"
                [cpCancelButton]="true"
                (colorPickerChange)="applyLiveColor()"
                (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
                [cpEyeDropper]="true"
                [cpPosition]="'top'"
                [cpWidth]="'180px'"
                [cpDisableInput]="true"
                [cpPresetColors]="presetColors"
                (colorPickerClose)="this.isColorPickerOpened = false"
              ></div>
              <input
                type="text"
                class="color-value"
                (click)="stopAllAnimations()"
                [(ngModel)]="theme.defaultTextColor"
                (input)="onHexColorInput($event, 'defaultTextColor')"
                (keypress)="onHexColorKeyPress($event)"
                (paste)="onHexColorPaste($event)"
                maxlength="9"
                placeholder="#000000"
              />
            </div>
          </div>
          <h3 class="group-title">Form Header</h3>
          <div
            class="color-control"
            [class.advanced-controls]="true"
            [style.display]="advancedView ? 'flex' : 'none'"
            (mouseenter)="animateColor('form.header.primaryBackgroundColor')"
            (mouseleave)="stopAllAnimations()"
          >
            <label class="color-label">Header Background</label>
            <div class="color-picker-wrapper">
              <div
                class="color-picker-input"
                [style.background]="theme.form.header.primaryBackgroundColor"
                [(colorPicker)]="theme.form.header.primaryBackgroundColor"
                [cpOKButton]="true"
                [cpOKButtonText]="'Select'"
                [cpSaveClickOutside]="true"
                [cpCancelButton]="true"
                (colorPickerChange)="applyLiveColor()"
                (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
                [cpEyeDropper]="true"
                [cpPosition]="'right'"
                [cpWidth]="'180px'"
                [cpDisableInput]="true"
                [cpPresetColors]="presetColors"
                (colorPickerClose)="this.isColorPickerOpened = false"
              ></div>
              <input
                type="text"
                class="color-value"
                (click)="stopAllAnimations()"
                [(ngModel)]="theme.form.header.primaryBackgroundColor"
                (input)="onHexColorInput($event, 'form.header.primaryBackgroundColor')"
                (keypress)="onHexColorKeyPress($event)"
                (paste)="onHexColorPaste($event)"
                maxlength="9"
                placeholder="#000000"
              />
            </div>
          </div>
          <div
            class="color-control"
            (mouseenter)="animateColor('form.header.textColor')"
            (mouseleave)="stopAllAnimations()"
          >
            <label class="color-label">Header Text</label>
            <div class="color-picker-wrapper">
              <div
                class="color-picker-input"
                [style.background]="theme.form.header.textColor"
                [(colorPicker)]="theme.form.header.textColor"
                [cpOKButton]="true"
                [cpOKButtonText]="'Select'"
                [cpSaveClickOutside]="true"
                [cpCancelButton]="true"
                (colorPickerChange)="applyLiveColor()"
                (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
                [cpEyeDropper]="true"
                [cpPosition]="'top'"
                [cpWidth]="'180px'"
                [cpDisableInput]="true"
                [cpPresetColors]="presetColors"
                (colorPickerClose)="this.isColorPickerOpened = false"
              ></div>
              <input
                type="text"
                class="color-value"
                (click)="stopAllAnimations()"
                [(ngModel)]="theme.form.header.textColor"
                (input)="onHexColorInput($event, 'form.header.textColor')"
                (keypress)="onHexColorKeyPress($event)"
                (paste)="onHexColorPaste($event)"
                maxlength="9"
                placeholder="#000000"
              />
            </div>
          </div>
          <div
            class="color-control"
            (mouseenter)="animateColor('form.header.itemsColor')"
            (mouseleave)="stopAllAnimations()"
          >
            <label class="color-label">Buttons</label>
            <div class="color-picker-wrapper">
              <div
                class="color-picker-input"
                [style.background]="theme.form.header.itemsColor"
                [(colorPicker)]="theme.form.header.itemsColor"
                [cpOKButton]="true"
                [cpOKButtonText]="'Select'"
                [cpSaveClickOutside]="true"
                [cpCancelButton]="true"
                (colorPickerChange)="applyLiveColor()"
                (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
                [cpEyeDropper]="true"
                [cpPosition]="'top'"
                [cpWidth]="'180px'"
                [cpDisableInput]="true"
                [cpPresetColors]="presetColors"
                (colorPickerClose)="this.isColorPickerOpened = false"
              ></div>
              <input
                type="text"
                class="color-value"
                (click)="stopAllAnimations()"
                [(ngModel)]="theme.form.header.itemsColor"
                (input)="onHexColorInput($event, 'form.header.itemsColor')"
                (keypress)="onHexColorKeyPress($event)"
                (paste)="onHexColorPaste($event)"
                maxlength="9"
                placeholder="#000000"
              />
            </div>
          </div>
          <div
            class="color-control"
            (mouseenter)="animateColor('form.header.itemsTextColor')"
            (mouseleave)="stopAllAnimations()"
          >
            <label class="color-label">Button Text</label>
            <div class="color-picker-wrapper">
              <div
                class="color-picker-input"
                [style.background]="theme.form.header.itemsTextColor"
                [(colorPicker)]="theme.form.header.itemsTextColor"
                [cpOKButton]="true"
                [cpOKButtonText]="'Select'"
                [cpSaveClickOutside]="true"
                [cpCancelButton]="true"
                (colorPickerChange)="applyLiveColor()"
                (colorPickerOpen)="stopAllAnimations(); this.isColorPickerOpened = true"
                [cpEyeDropper]="true"
                [cpPosition]="'top'"
                [cpWidth]="'180px'"
                [cpDisableInput]="true"
                [cpPresetColors]="presetColors"
                (colorPickerClose)="this.isColorPickerOpened = false"
              ></div>
              <input
                type="text"
                class="color-value"
                (click)="stopAllAnimations()"
                [(ngModel)]="theme.form.header.itemsTextColor"
                (input)="onHexColorInput($event, 'form.header.itemsTextColor')"
                (keypress)="onHexColorKeyPress($event)"
                (paste)="onHexColorPaste($event)"
                maxlength="9"
                placeholder="#000000"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form Preview Component -->
    <div class="form-preview">
      <p-card class="form-card" data-cy="form-card" [style]="{ background: theme.form.backgroundColor }">
        <ng-template pTemplate="header">
          <div class="form-card-header">
            <h1>Location Name</h1>
            <div class="location">
              <button
                #btnLocationCancel
                type="button"
                pButton
                icon="pi pi-ban"
                label="Cancel"
                class="form-header-items"
                data-cy="form-cancel-button"
              ></button>
              <button
                #btnLocationSave
                type="button"
                pButton
                icon="pi pi-check-square"
                label="Save"
                class="form-header-items"
                data-cy="form-save-button"
              ></button>
            </div>
          </div>
        </ng-template>

        <div class="custom-form-body">
          <div>
            <p-divider align="center" type="solid">
              <h5 class="information-form-label-wrapper"><b>Location</b></h5>
            </p-divider>
          </div>
          <div>
            <form class="d-flex flex-column gap-4">
              <div class="align-items-center flex information-form-controls-wrapper justify-content-lg-evenly">
                <div class="information-form-controls-wrapper">
                  <span class="information-form-label-wrapper">
                    <label> Name </label>
                  </span>
                  <span class="information-form-label-wrapper">
                    <label> Enroll & Pay </label>
                  </span>
                </div>
              </div>

              <div class="align-items-center flex information-form-controls-wrapper justify-content-lg-evenly">
                <div class="information-form-controls-wrapper">
                  <span class="information-form-label-wrapper">
                    <label> Address </label>
                  </span>
                  <span class="information-form-label-wrapper">
                    <label> 514 Via De La Valle</label>
                  </span>
                </div>
              </div>

              <div class="align-items-center flex information-form-controls-wrapper justify-content-lg-evenly">
                <div class="information-form-controls-wrapper">
                  <span class="information-form-label-wrapper">
                    <label> Phone </label>
                  </span>
                  <span class="information-form-label-wrapper">
                    <label> (866) 942-5500</label>
                  </span>
                </div>
              </div>

              <div class="align-items-center flex information-form-controls-wrapper justify-content-lg-evenly">
                <div class="information-form-controls-wrapper">
                  <span class="information-form-label-wrapper">
                    <label> Timezone </label>
                  </span>
                  <span class="information-form-label-wrapper">
                    <label>(GMT-08:00) Pacific Time (US & Canada) </label>
                  </span>
                </div>
              </div>
            </form>
          </div>
        </div>
      </p-card>
    </div>
  </div>
</div>
